import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppStateProvider } from './AppState';
/**
* MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
* For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
*/
// @TEMPLATE_@MSAL: Uncomment to use MSAL for authentication.
// Also install
// "@azure/msal-browser",
// "@azure/msal-react",
// and set up your .env file with the necessary variables,
// and find all @TEMPLATE_@MSAL comments to uncomment the necessary code.

import { initializeMsal } from './api/WebUtils';
import { msalConfig } from "./authConfig.js";
import { PublicClientApplication } from "@azure/msal-browser"

// Clear stale MSAL tokens from a previous deployment so users are forced to
// re-authenticate rather than sending expired/mismatched tokens to the backend.
const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION;
if (BUILD_VERSION) {
    const storedVersion = localStorage.getItem('_app_version');
    if (storedVersion !== BUILD_VERSION) {
        Object.keys(localStorage)
            .filter(k => k.startsWith('msal.'))
            .forEach(k => localStorage.removeItem(k));
        localStorage.setItem('_app_version', BUILD_VERSION);
    }
}

const msalInstance = new PublicClientApplication(msalConfig);

initializeMsal(msalInstance).then((shouldRenderApp) => {
    if (!shouldRenderApp) {
        return;
    }

    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(
        <React.StrictMode>
            <AppStateProvider>
                <App
                    msalInstance={msalInstance}
                />
            </AppStateProvider>
        </React.StrictMode>
    );
}).catch((error) => {
    console.error('MSAL initialization error:', error);
});



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
